import { render, staticRenderFns } from "./PosShipmentDrawer.vue?vue&type=template&id=6e13b664&scoped=true"
import script from "./PosShipmentDrawer.vue?vue&type=script&lang=js"
export * from "./PosShipmentDrawer.vue?vue&type=script&lang=js"
import style0 from "./PosShipmentDrawer.vue?vue&type=style&index=0&id=6e13b664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13b664",
  null
  
)

export default component.exports